import { defineStore } from 'pinia'

export const useUiStore = defineStore('ui', {
  state: () => ({
    pendingRequests: 0
  }),
  getters: {
    isLoading: (state) => state.pendingRequests > 0
  },
  actions: {
    requestStarted() {
      this.pendingRequests += 1
    },
    requestFinished() {
      this.pendingRequests = Math.max(0, this.pendingRequests - 1)
    }
  }
})
